const actions = {
  ADD_BREADCRUMBS: 'ADD_BREADCRUMBS',
  APPEND_BREADCRUMBS: 'APPEND_BREADCRUMBS',

  add_beadcrumbs: (value) => {
    return {
      type: actions.ADD_BREADCRUMBS,
      value: value,
    };
  },

  append_beadcrumbs: (value) => {
    return {
      type: actions.APPEND_BREADCRUMBS,
      value: value,
    };
  },
};
export default actions;
